import React, {Component} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';

import requireAuth from '../auth/requireAuth';
import {DataAdminRole} from '../util/entitlements';

import Run from './Run';

import * as actions from '../../actions/aggregate';
import {getTasks} from '../../actions/task';

class Aggregates extends Component {
	constructor(props) {
		super(props);
		this.runOne = this.runOne.bind(this);
		this.runSome = this.runSome.bind(this);
		this.runAll = this.runAll.bind(this);
		this.runManual = this.runManual.bind(this);
	}

	runOne(id, revisionID, options) {
		if (parseInt(id, 10) === 1) {
			this.props.runAnalystConversions(revisionID, options);
		} else if (parseInt(id, 10) === 2) {
			this.props.runAllAggregates(revisionID, options);
		}
	}

	runSome(ids, revisionID, options) {
		this.props.runAnalystConversions(revisionID, options);
	}

	runAll(revisionID, options) {
		this.props.runAnalystConversions(revisionID, options);
	}

	runManual({marketIDs, indicatorIDs}, options) {
		let marketsArray = [];
		if (marketIDs !== '') {
			marketsArray = marketIDs.split(',').map((id) => parseInt(id, 10));
		}
		let indicatorsArray = [];
		if (indicatorIDs !== '') {
			indicatorsArray = indicatorIDs.split(',').map((id) => parseInt(id, 10));
		}
		this.props.runManualAggregate(marketsArray, indicatorsArray, this.props.revisions.currentRevisionID, options);
	}

	render() {
		if (this.props.aggregates.order.length > 0 && this.props.revisions.currentRevisionID) {
			return (
				<Run
					label="Aggregate"
					runnables={this.props.aggregates}
					runOne={this.runOne}
					runSome={this.runSome}
					runAll={this.runAll}
					runManual={this.runManual}
					getTasks={this.props.getTasks}
					revisionID={this.props.revisions.currentRevisionID}
					toggles={[
						{
							name: 'Baseline',
							queryParam: 'isBaseline',
							value: false,
						},
						{
							name: 'Reprocess Dependencies',
							queryParam: 'reprocessDependencies',
							value: true,
						},
					]}
					taskTypeID={7}
					checkType="radio"
				/>
			);
		} else {
			return <div>Loading...</div>;
		}
	}
}

function mapStateToProps({aggregates, revisions}) {
	return {aggregates, revisions};
}

export default compose(connect(mapStateToProps, {...actions, getTasks}), requireAuth(DataAdminRole))(Aggregates);
